import {PaymentProvider} from "../generated/graphql";

/**
 * Plan mollie-treatment-follows-method — Baustein 5 (Frontend).
 *
 * Client-Diskriminator: Eine Buchung wird genau dann als "Mollie/Online"
 * behandelt, wenn sie mindestens einen ScheduledPayment mit
 * `paymentProvider === Mollie` hat — analog zum Server-`shouldStartMollieFlow`
 * und zur bestehenden `BookingListColumns`-Logik.
 *
 * Das ersetzt den bisherigen kurs-basierten Switch
 * (`course.allowMolliePayment === true`): Nach einem Umbuchen/Methodenwechsel
 * (Server-Re-Derive, Bausteine 1-4) folgt der angezeigte Strategy-Switch jetzt
 * der tatsächlichen Bezahlmethode der Buchung, nicht mehr dem Kurs.
 *
 * Node 14 / TS 4.7 / React 17 kompatibel (kein findLast etc.).
 */
export const bookingHasMolliePayment = (
    scheduledPayments: Array<{paymentProvider?: PaymentProvider | null}> | null | undefined,
): boolean => scheduledPayments?.some((sp) => sp.paymentProvider === PaymentProvider.Mollie) ?? false;
